
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30297',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30297",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54594",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8023",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11481",
  "I18n": "static-7.1628",
  "quartz": "static-1.7046",
  "quartz-config": "static-1.824",
  "quartz-core": "static-1.6265",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.794",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54581",
  "feedback-utils": "static-1.54585",
  "forms-embed-utils-lib": "static-1.4473",
  "forms-utils-lib": "static-1.12603",
  "foundations-assets": "static-1.4876",
  "foundations-components": "static-1.7956",
  "foundations-theming": "static-1.4428",
  "hub-http": "static-1.6231",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11788",
  "icons": "static-2.648",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3922",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5350",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57512",
  "transmute": "static-2.85",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8427",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3405",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3323",
  "quartz-webpack": "static-1.3270",
  "foundations-theming-specialty": "static-1.2144",
  "property-description-translator": "static-1.3854",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3134",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4337",
  "jasmine-runner": "static-1.6474",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4657",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.721",
  "quartz-head": "static-1.711",
  "quartz-i18n": "static-1.721",
  "quartz-routing": "static-1.476",
  "quartz-test": "static-1.721",
  "quartz-tracking": "static-1.425",
  "ui-fonts": "static-1.743",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7256",
  "reference-resolvers": "static-1.8180",
  "sanitize-text": "static-1.8151",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10375",
  "sanitize": "static-1.4486",
  "outpost": "static-1.4191",
  "rpc-client-utils": "static-1.4662",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4225",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9434",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1975",
  "bend-plugin-foundations-theming": "static-1.2911",
  "foundations-theming-base": "static-1.3413",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.86",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "ai-components-ui-library": "static-1.9007",
  "atom": "static-1.5082",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7767",
  "ContentUtils": "static-1.68396",
  "data-token-picker": "static-1.16427",
  "file-manager-components": "static-1.23655",
  "FileManagerCore": "static-1.39154",
  "FileManagerLib": "static-1.39295",
  "frontend-preferences-client": "static-1.7937",
  "hub-http-contrib": "static-1.3052",
  "interframe": "static-3.4769",
  "layout-dnd-components": "static-1.12466",
  "layout-dnd-utils": "static-1.11441",
  "property-translator": "static-1.5410",
  "react-codemirror": "static-1.10636",
  "react-colorpicker": "static-2.10216",
  "reference-resolvers-lite": "static-1.8104",
  "rich-text-lib": "static-1.19853",
  "tinymce-data": "static-1.40483",
  "tinymce-themes": "static-1.56368",
  "ui-addon-emoji-picker": "static-1.9897",
  "ui-addon-sales-email": "static-1.5220",
  "ui-brand-identity-lib": "static-1.15314",
  "bender-build-tools": "static-1.3205",
  "hub-http-shared-msw-handlers": "static-1.9985",
  "hubspotter-http-shared-msw-handlers": "static-1.9983",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.72",
  "chirp-fetch": "static-1.1897",
  "chatspot-core": "static-1.21381",
  "copilot-toolkit": "static-1.11160",
  "customer-data-objects-ui-components": "static-1.13037",
  "data-fetching-client": "static-1.9678",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4771",
  "ui-addon-video-player": "static-1.8712",
  "ui-coaching-tips": "static-1.28588",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "cms-field-types": "static-1.4822",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16177",
  "customer-data-objects": "static-1.7679",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4661",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4164",
  "ui-addon-iframeable": "static-1.9067",
  "video-components-external": "static-1.11304",
  "video-data-lib": "static-1.34962",
  "audio-components": "static-1.5929",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29313",
  "FileManagerImages": "static-1.36806",
  "foundations-components-legacy": "static-1.981",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.8990",
  "urlinator": "static-1.4546",
  "video-components": "static-1.13307",
  "video-embed": "static-1.35796",
  "ts-schema": "static-1.4085",
  "ContentData": "static-1.68471",
  "layout-data-lib": "static-1.9766",
  "react-dnd-compat": "static-1.4624",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1551",
  "external-options-client-types": "static-1.4164",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6894",
  "hs-promise-utils": "static-1.5601",
  "inbound-db-properties-service-client": "static-1.3851",
  "NamespacedHubStyle": "static-2.9064",
  "growth-onboarding-confetti": "static-1.3076",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11158",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5557",
  "magpie-types": "static-1.5017",
  "simple-logging-lib": "static-1.3060",
  "avatar-components": "static-1.2506",
  "customer-data-ui-utilities": "static-1.9836",
  "growth-onboarding-feedback-components": "static-1.6590",
  "flux-actions": "static-1.338",
  "hubspot-apollo-client": "static-1.4889",
  "integrations-error-boundary-lib": "static-1.13592",
  "integrations-tracking-lib": "static-1.5610",
  "laboratory-lib": "static-3.7165",
  "native-integrations-shared-strings": "static-1.7791",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10174",
  "unified-auth": "static-1.504",
  "navigation-messaging": "static-1.7394",
  "content-media-composition-data-lib": "static-1.12348",
  "content-media-compositions": "static-2.16355",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18946",
  "unified-auth-core-lib": "static-1.786",
  "social-insights-client-types": "static-1.22142",
  "advanced-menus-core": "static-1.15143",
  "advanced-menus-lib": "static-1.12082",
  "ExportDialog": "static-6.10398",
  "ui-memberships-settings-lib": "static-1.34075",
  "conditional-properties-service-client": "static-1.3802",
  "crm-pipelines-api-client-types": "static-1.4144",
  "fdsr-migration-layer": "static-1.13",
  "framework-builder-read-service-client": "static-1.4010",
  "framework-data-schema-quick-fetch": "static-1.6799",
  "inbound-db-meta-service-client": "static-1.3591",
  "multi-currency-client-types": "static-1.3696",
  "persist-promise": "static-1.3708",
  "foundations-components-test-utils": "static-1.5439",
  "reactive-lib": "static-1.734",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.348",
  "universal-page-editor-lib": "static-1.3022",
  "google-sheets-integration-lib": "static-1.269",
  "microsoft-drive-integration-lib": "static-1.387",
  "slack-ui-library": "static-1.10402",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3740",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15142",
  "simple-menus-lib": "static-1.16659",
  "crm-record-cards-service-types": "static-1.3602",
  "location-customization-utils-lib": "static-1.9293",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30297",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54594",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8023",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11481",
  "I18n": "/I18n/static-7.1628",
  "quartz": "/quartz/static-1.7046",
  "quartz-config": "/quartz-config/static-1.824",
  "quartz-core": "/quartz-core/static-1.6265",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.794",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54581",
  "feedback-utils": "/feedback-utils/static-1.54585",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4473",
  "forms-utils-lib": "/forms-utils-lib/static-1.12603",
  "foundations-assets": "/foundations-assets/static-1.4876",
  "foundations-components": "/foundations-components/static-1.7956",
  "foundations-theming": "/foundations-theming/static-1.4428",
  "hub-http": "/hub-http/static-1.6231",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11788",
  "icons": "/icons/static-2.648",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3922",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5350",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57512",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8427",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3405",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3323",
  "quartz-webpack": "/quartz-webpack/static-1.3270",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2144",
  "property-description-translator": "/property-description-translator/static-1.3854",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3134",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4337",
  "jasmine-runner": "/jasmine-runner/static-1.6474",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4657",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.721",
  "quartz-head": "/quartz-head/static-1.711",
  "quartz-i18n": "/quartz-i18n/static-1.721",
  "quartz-routing": "/quartz-routing/static-1.476",
  "quartz-test": "/quartz-test/static-1.721",
  "quartz-tracking": "/quartz-tracking/static-1.425",
  "ui-fonts": "/ui-fonts/static-1.743",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7256",
  "reference-resolvers": "/reference-resolvers/static-1.8180",
  "sanitize-text": "/sanitize-text/static-1.8151",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10375",
  "sanitize": "/sanitize/static-1.4486",
  "outpost": "/outpost/static-1.4191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4662",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4225",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9434",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1975",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2911",
  "foundations-theming-base": "/foundations-theming-base/static-1.3413",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.86",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9007",
  "atom": "/atom/static-1.5082",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7767",
  "ContentUtils": "/ContentUtils/static-1.68396",
  "data-token-picker": "/data-token-picker/static-1.16427",
  "file-manager-components": "/file-manager-components/static-1.23655",
  "FileManagerCore": "/FileManagerCore/static-1.39154",
  "FileManagerLib": "/FileManagerLib/static-1.39295",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7937",
  "hub-http-contrib": "/hub-http-contrib/static-1.3052",
  "interframe": "/interframe/static-3.4769",
  "layout-dnd-components": "/layout-dnd-components/static-1.12466",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11441",
  "property-translator": "/property-translator/static-1.5410",
  "react-codemirror": "/react-codemirror/static-1.10636",
  "react-colorpicker": "/react-colorpicker/static-2.10216",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8104",
  "rich-text-lib": "/rich-text-lib/static-1.19853",
  "tinymce-data": "/tinymce-data/static-1.40483",
  "tinymce-themes": "/tinymce-themes/static-1.56368",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9897",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5220",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15314",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9985",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9983",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.72",
  "chirp-fetch": "/chirp-fetch/static-1.1897",
  "chatspot-core": "/chatspot-core/static-1.21381",
  "copilot-toolkit": "/copilot-toolkit/static-1.11160",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13037",
  "data-fetching-client": "/data-fetching-client/static-1.9678",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4771",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8712",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28588",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "cms-field-types": "/cms-field-types/static-1.4822",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16177",
  "customer-data-objects": "/customer-data-objects/static-1.7679",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4661",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4164",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9067",
  "video-components-external": "/video-components-external/static-1.11304",
  "video-data-lib": "/video-data-lib/static-1.34962",
  "audio-components": "/audio-components/static-1.5929",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29313",
  "FileManagerImages": "/FileManagerImages/static-1.36806",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.981",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.8990",
  "urlinator": "/urlinator/static-1.4546",
  "video-components": "/video-components/static-1.13307",
  "video-embed": "/video-embed/static-1.35796",
  "ts-schema": "/ts-schema/static-1.4085",
  "ContentData": "/ContentData/static-1.68471",
  "layout-data-lib": "/layout-data-lib/static-1.9766",
  "react-dnd-compat": "/react-dnd-compat/static-1.4624",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1551",
  "external-options-client-types": "/external-options-client-types/static-1.4164",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6894",
  "hs-promise-utils": "/hs-promise-utils/static-1.5601",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3851",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9064",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3076",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11158",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5557",
  "magpie-types": "/magpie-types/static-1.5017",
  "simple-logging-lib": "/simple-logging-lib/static-1.3060",
  "avatar-components": "/avatar-components/static-1.2506",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9836",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6590",
  "flux-actions": "/flux-actions/static-1.338",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4889",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13592",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5610",
  "laboratory-lib": "/laboratory-lib/static-3.7165",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7791",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10174",
  "unified-auth": "/unified-auth/static-1.504",
  "navigation-messaging": "/navigation-messaging/static-1.7394",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12348",
  "content-media-compositions": "/content-media-compositions/static-2.16355",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18946",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.786",
  "social-insights-client-types": "/social-insights-client-types/static-1.22142",
  "advanced-menus-core": "/advanced-menus-core/static-1.15143",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12082",
  "ExportDialog": "/ExportDialog/static-6.10398",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34075",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3802",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4144",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.13",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4010",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6799",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3591",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3696",
  "persist-promise": "/persist-promise/static-1.3708",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5439",
  "reactive-lib": "/reactive-lib/static-1.734",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.348",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3022",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.269",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.387",
  "slack-ui-library": "/slack-ui-library/static-1.10402",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3740",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15142",
  "simple-menus-lib": "/simple-menus-lib/static-1.16659",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3602",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9293",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
